<template>
  <b-tab>
    <template #title>
      {{ user.username || "User" + (indexUser + 1) }}
      <span class="delete-tab" @click="removeUser(indexUser)">X</span>
    </template>
    <indica-form
      ref="user"
      table-name="UserAccounts"
      :save-to-store="true"
      store-name="users"
      :show-submit="false"
      :store-index="indexUser"
      :show-many="false"
      :show-edit="false"
      :show-return="false"
    />
    <b-form-group
      :id="'Select Roles'"
      horizontal
      label-class="text-sm-right"
      label-cols="3"
      label="Select Roles"
    >
      <indica-selector
        :show-table-options="false"
        table-name="AccountRoles"
        :save-to-store="true"
        :store-index="indexUser"
        store-name="accountRoles"
        :other-options="[...getAllStoreInfo.roles,...getAccountRolesForTag]"
      />
    </b-form-group>
  </b-tab>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapGetters } from "vuex";
import IndicaForm from "@/utils/forms/indica-form";
import IndicaCheckBox from "@/utils/forms/indica-check-box";
import IndicaSelector from "@/utils/forms/indica-selector";

export default {
  name: "UserToCreate",
  components:{IndicaSelector, IndicaForm,IndicaCheckBox},
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    indexUser: {
      type: Number,
      default: 0,
    },
  },
  watch: {},
  methods: {
    removeUser(index) {
      const payload = {};
      payload["storeName"] = "users";
      payload["index"] = index;
      this.$store.dispatch("removeFromArray", payload);
      this.$parent.$forceUpdate();
    },
  },
  computed: {
    ...mapGetters(["getAllStoreInfo",'getRolesToCreate','getAccountRolesForTag']),
  },
};
</script>

<style lang="scss" scoped>
.new-id {
  font-size: 11px;
  color: gray;
}

.error {
  color: red;
}

.ok {
  color: green;
}

.message-error {
  font-size: 16px;
  color: red;
  text-align: center;
  padding: 30px;
}

.delete-tab {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  padding: 2px 5px;
  font-size: 15px;
  transition: 0.3s;

  &:hover {
    font-size: 13px;
  }
}
</style>
